import styled from "styled-components";

export const StyledLoadingWrapper = styled.div`
display:flex;
flex-direction:column;
`
